import { ReactComponent as letterA} from "../images/letterA.svg";
import { ReactComponent as letterB} from "../images/letterB.svg";
import { ReactComponent as letterC} from "../images/letterC.svg";
import { ReactComponent as letterD} from "../images/letterD.svg";
import { ReactComponent as letterE} from "../images/letterE.svg";
import { ReactComponent as letterF} from "../images/letterF.svg";
import { ReactComponent as letterG} from "../images/letterG.svg";
import { ReactComponent as letterH} from "../images/letterH.svg";
import { ReactComponent as letterI} from "../images/letterI.svg";
import { ReactComponent as letterJ} from "../images/letterJ.svg";
import { ReactComponent as letterK} from "../images/letterK.svg";
import { ReactComponent as letterL} from "../images/letterL.svg";
import { ReactComponent as letterM} from "../images/letterM.svg";
import { ReactComponent as letterN} from "../images/letterN.svg";
import { ReactComponent as letterO} from "../images/letterO.svg";
import { ReactComponent as letterP} from "../images/letterP.svg";
import { ReactComponent as letterQ} from "../images/letterQ.svg";
import { ReactComponent as letterR} from "../images/letterR.svg";
import { ReactComponent as letterS} from "../images/letterS.svg";
import { ReactComponent as letterT} from "../images/letterT.svg";
import { ReactComponent as letterU} from "../images/letterU.svg";
import { ReactComponent as letterV} from "../images/letterV.svg";
import { ReactComponent as letterW} from "../images/letterW.svg";
import { ReactComponent as letterX} from "../images/letterX.svg";
import { ReactComponent as letterY} from "../images/letterY.svg";
import { ReactComponent as letterZ} from "../images/letterZ.svg";

export default function ProfileIcon({initialLetter="", size=24, ...props}) {
    let IMAGE_MAP = {
        "A": letterA,
        "B": letterB,
        "C": letterC,
        "D": letterD,
        "E": letterE,
        "F": letterF,
        "G": letterG,
        "H": letterH,
        "I": letterI,
        "J": letterJ,
        "K": letterK,
        "L": letterL,
        "M": letterM,
        "N": letterN,
        "O": letterO,
        "P": letterP,
        "Q": letterQ,
        "R": letterR,
        "S": letterS,
        "T": letterT,
        "U": letterU,
        "V": letterV,
        "W": letterW,
        "X": letterX,
        "Y": letterY,
        "Z": letterZ
    };

    const ICON = IMAGE_MAP[initialLetter.toUpperCase()];

    if (!ICON) {
        return <></>;
    }

    return (
        <ICON style={{width: size, height: size, flexShrink: 0, ...props.style}}/>
    );



}